import * as React from 'react';
import { createPortal } from 'react-dom';
import HelpDocument from '../../../models/helpDocument';
import helpContentCssUrl from 'url:./help-document-editor.css';

interface Props {
  document: HelpDocument;
  showAltText?: boolean;
}

const ShadowDOMContent = ({ document, showAltText }: Props) => {
  const [shadowRoot, setShadowRoot] = React.useState(null);
  const node = React.useRef(null);

  React.useLayoutEffect(() => {
    setShadowRoot(node.current.attachShadow({ mode: 'open' }));
  }, []);

  return (
    <div ref={node}>
      {shadowRoot &&
        createPortal(
          <React.Fragment>
            <link rel="stylesheet" href={helpContentCssUrl} />
            <div
              dangerouslySetInnerHTML={{
                __html: showAltText ? document.alternative : document.content
              }}
            />
          </React.Fragment>,
          shadowRoot
        )}
    </div>
  );
};

export default ShadowDOMContent;
